export enum Addon {
    Baa = 'baa',
}